<div fxLayout fxLayoutAlign="start center" fxLayoutGap="16px" style="margin-bottom: 32px">
  <img src="/assets/iconography/agoda.svg" class="agoda-logo" />
  <h2 class="nomargin">We want to receive your guest messages!</h2>
</div>

<div class="info-box">
  <div class="info-container margin-bottom-32">

    ...

  </div>

  <div class="text-center">

  </div>
</div>

<div style="margin-top: 32px" fxLayout fxLayoutGap="10px" fxLayoutAlign="end center">
  <sbnb-button label="Back" type="secondary" (click)="back()"></sbnb-button>
  <sbnb-button label="Continue" (click)="progress()"></sbnb-button>
</div>
